import { logVerbose, logVerboseAsync, LoggerFactory } from '@metaos/mfs-telemetry';
import { MFS_CORE_VERSION } from '../version';
import { logger } from '../logger';
import { base64Encoder } from './base64Encoder';
import { mfsError } from '../errors/loaderErrors';
/**
 * Create an MfsLoggerContext.
 *
 * @param response PushChannelInfo response from MfsServices.
 * @param config MfsConfig used to create the MfsClient.
 * @returns MfsLoggerContext to be used to set the logging context.
 */
export function createLoggerContext(response, config) {
    return logVerbose(logger, 'createLoggerContext', () => {
        var _a, _b;
        return {
            user: {
                userId: response.userId,
                passportUserId: response.passportUserId,
                tenantId: response.userTenantId,
                tenantDataBoundaryRestriction: response.tenantDataBoundaryRestriction,
            },
            appInfo: {
                appId: response.applicationId,
                appPlatform: 'web',
                appVersion: ((_a = config.hostConfig) === null || _a === void 0 ? void 0 : _a.dataModelVersion) === undefined
                    ? undefined
                    : 'v' + config.hostConfig.dataModelVersion.toString(),
                mfsCoreVersion: MFS_CORE_VERSION,
                appHostingPlatform: config.appHostingPlatform,
                clientRing: (_b = config.clientRing) !== null && _b !== void 0 ? _b : '',
            },
            sessionId: config.sessionId,
            serviceLoggingInfo: {
                isLoggingEnabled: response.clientLoggingInfo.isLoggingEnabled,
                isConsoleLoggingEnabled: response.clientLoggingInfo.isConsoleLoggingEnabled,
                mfsServiceBuildNumber: response.clientLoggingInfo.mfsServiceBuildNumber,
                mfsServiceEnvironment: response.clientLoggingInfo.mfsServiceEnvironment,
                ariaInfo: {
                    token: response.clientLoggingInfo.ariaTenantToken,
                    namespacePrefix: response.clientLoggingInfo.ariaTenantNamespace,
                },
            },
        };
    });
}
/** Set logging context based on current user's information and logging configs coming from MfsService response */
export function setLoggingContext(loggerContext, sink) {
    return logVerbose(logger, 'setLoggingContext', () => {
        LoggerFactory.getInstance().setContext(loggerContext, sink);
    });
}
/**
 * Set logging context based on current user's information and logging configs coming from MfsService response and
 * resolving sink from a callback
 */
export async function setLoggingContextFromCallback(loggerContext, sink) {
    return logVerboseAsync(logger, 'setLoggingContextFromCallback', async () => {
        return setLoggingContext(loggerContext, await sink());
    });
}
/**
 * Sets the podLocationId using the Pod that is loaded for logging.
 *
 * @param podId ID of the Pod that is loaded
 */
export function setPodLocationIdFromPodId(podId) {
    return logVerbose(logger, 'setPodLocationIdFromPodId', () => {
        LoggerFactory.getInstance().setPodLocationId(getDriveItemId(podId));
    });
}
/**
 * Gets the driveItemId using the given podId.
 *
 * @param podId ID of a Pod
 */
export function getDriveItemId(podId) {
    const driveItemIdIndex = 3;
    const podIdBuildingBlocksSize = 5;
    const decodedPodId = base64Encoder.atob(podId);
    const podIdComponents = decodedPodId.split('|');
    if (!decodedPodId.startsWith('ODSP') || podIdComponents.length !== podIdBuildingBlocksSize) {
        throw mfsError.invalidPodId();
    }
    return podIdComponents[driveItemIdIndex];
}
//# sourceMappingURL=setLoggerContext.js.map